import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { AcademicComponent } from './pages/academic/academic.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from './pages/header/header.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PubDisclosureComponent } from './pages/pub-disclosure/pub-disclosure.component';
import { NewsComponent } from './pages/news/news.component';
import { FAQComponent } from './pages/faq/faq.component';
import { FooterComponent } from './pages/footer/footer.component';
import { HomeFaqComponent } from './pages/home/home-faq/home-faq.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { DirectorMsgComponent } from './pages/about-us/director-msg/director-msg.component';
import {MatDividerModule} from '@angular/material/divider';
import { MatSelectModule } from "@angular/material/select";
import {MatTabsModule} from '@angular/material/tabs';
import { CurriculamComponent } from './pages/curriculam/curriculam.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTableModule} from '@angular/material/table';
import { DressesComponent } from './pages/dresses/dresses.component';
import { FeesComponent } from './pages/fees/fees.component';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        AboutUsComponent,
        AcademicComponent,
        HeaderComponent,
        GalleryComponent,
        ContactComponent,
        PubDisclosureComponent,
        NewsComponent,
        FAQComponent,
        FooterComponent,
        HomeFaqComponent,
        DirectorMsgComponent,
        CurriculamComponent,
        DressesComponent,
        FeesComponent
        
    ],
    providers: [],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonToggleModule,
        MatTableModule,
        HttpClientModule,
    ]
})
export class AppModule { }
